import { useBlocker } from 'react-router-dom';

/**
 * Intercept SPA navigation (including browser Back) while triage has unsaved
 * work or a pending operation. The dialog owns confirmation and calls proceed
 * or reset on the returned blocker. Hard navigation uses beforeunload instead.
 */
export function useTriageNavigationGuard(shouldBlock: boolean) {
  return useBlocker(shouldBlock);
}
